<template>
<div class="form-grid">
        <small class="tx-lightgrey-1" style="font-size: calc(0.2vw + 0.60rem)">
            Los campos marcados con <strong class="tx-black">*</strong> son requeridos
        </small>
        <div class="form-group col-16">
            <label class="form-label tx-gray-ad" for="brands_select">
            Marca*
            </label>
            <ValidationProvider name="marca" rules="required" v-slot="{ errors }">
            <v-select @click.native="loadBrands()"
                        v-model="filters.brands"
                        :reduce="brands => brands"
                        :options="getBrands()"
                        placeholder="Seleccionar"
                        label="name"
                        class="form-input"
                        name="brands"
                        :clearable=false
                        @input="loadModels()"
                        id="brands_select">
            <span slot="no-options">
                {{
                    brandsLoads && getBrands().length == 0
                        ? "Sin resultados"
                        : "Cargando..."
                }}
            </span>
            </v-select>
            <span class="tx-red-danger">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
        <div class="form-group col-16">
            <label class="form-label tx-gray-ad" for="models_select">
            Modelo*
            </label>
            <ValidationProvider name="modelo" rules="required" v-slot="{ errors }">
            <v-select
                        v-model="filters.models"
                        :reduce="models => models"
                        :options="getModels()"
                        placeholder="Seleccionar"
                        label="name"
                        class="form-input"
                        name="models"
                        :clearable=false
                        @input="loadYears()"
                        id="models_select">
                <span slot="no-options">{{
                        modelsLoads && getBrands().length == 0
                            ? "Sin resultados"
                            : "Seleccione una marca para continuar..."
                    }}</span>
            </v-select>
            <span class="tx-red-danger">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
        <div class="form-group col-16">
            <label class="form-label tx-gray-ad" for="year_select">
            Año*
            </label>
            <ValidationProvider name="año" rules="required" v-slot="{ errors }">

            <v-select
                    v-model="filters.years"
                    :reduce="years => years.value"
                    :options="getYears()"
                    placeholder="Seleccionar"
                    label="name"
                    class="form-input"
                    :clearable=false
                    name="year" id="year-select">
            <span slot="no-options">{{
                        modelsLoads && getModels().length == 0
                            ? "Sin resultados"
                            : "Seleccione una marca y un modelo para continuar..."
                    }}</span>
            </v-select>
            <span class="tx-red-danger">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
        <div class="form-group col-16">
            <label class="form-label tx-gray-ad" for="state_select">
            Estado*
            </label>
            <ValidationProvider name="estado" rules="required" v-slot="{ errors }">

            <v-select @click.native="loadStates()"
                    v-model="filters.states"
                    :reduce="states => states"
                    :options="getStates()"
                    placeholder="Seleccionar"
                    label="name"
                    class="form-input"
                    name="states"
                    :clearable=false
                    id="state_select">
            <span slot="no-options">
                {{
                    statesLoads && getStates().length == 0
                        ? "Sin resultados"
                        : "Cargando..."
                }}
            </span>
            </v-select>
            <span class="tx-red-danger">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
</div>
</template>

<script>
import {
  mapState
} from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate";
import es from 'vee-validate/dist/locale/es.json';

import * as rules from "vee-validate/dist/rules";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
Vue.component("v-select", vSelect);
localize('es', es);

export default {
    components:{
        ValidationObserver,
        ValidationProvider
    },
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      brandsLoads: false,
      modelsLoads: false,
      statesLoads: false
    }
  },
  watch: {
    filters: {
      handler(newVal) {
        this.$emit("filters", newVal);
      },
      deep: true
    },
    data: {
      handler(value) {
        if (value) {
          this.filters = value;
        }
      },
      deep: true
    }
  },
  methods: {
    loadBrands() {
        this.models = [];
        this.filters.models = []
        this.$store.dispatch("intelimotor/getBrands");
    },
    loadStates() {
        this.states = []
        this.$store.dispatch("catalog/getAllStates")
    },
    loadYears() {
        this.years = [];
        this.filters.years = []
        this.$store.dispatch("intelimotor/getYears",{
            brandId: this.filters.brands.value,
            modelId: this.filters.models.value
        });
    },
    loadModels () {
        this.years = []
        this.filters.years = []
        this.$store.dispatch('intelimotor/getModels', this.filters.brands.value)
    },
    getBrands() {
      return _.map(this.$store.state.intelimotor.brands, function (item, key) {
        return {
          name: item.name,
          value: item.id
        };
      });
      this.brandsLoads = true;
    },
    getStates() {
      return _.map(this.$store.state.catalog.statesAll, function (item, key) {
        return {
          name: item.name,
          value: item.id
        };
      });
    },
    getModels() {
      return _.map(this.$store.state.intelimotor.models, function (item, key) {
        return {
          name: item.name,
          value: item.id
        };
      });
    },
    getYears() {
      return _.map(this.$store.state.intelimotor.years, function (item, key) {
        return {
          name: item.name,
          value: item.name
        };
      });
    }
  }
}
</script>
